import { createFileRoute } from '@tanstack/react-router';
import { ConditionViewerDevRoute } from './-components';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/dev/condition-viewer')({
  component: ConditionViewerDevRoute,
});
